<template>
  <b-card no-body>
    <h6 slot="header" class="mb-0">
      <font-awesome-icon icon="cog" />เป้าหมาย/ตัวชี้วัดความสำเร็จ
    </h6>

    <table class="table table-striped table-bordered table-sm m-0">
      <thead>
        <tr>
          <th class="text-center align-middle" rowspan="2" width="50">ที่</th>
          <th class="text-center align-middle" rowspan="2">กิจกรรม</th>
          <th class="text-center" colspan="2">งบประมาณ</th>
          <th class="text-center" colspan="2">เป้าหมาย</th>
        </tr>
        <tr>
          <th class="text-center" width="100">แผน</th>
          <th class="text-center" width="100">ผล</th>
          <th class="text-center" width="100">แผน</th>
          <th class="text-center" width="100">ผล</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(outcome, index) in outcomes" :key="index">
          <td class="align-middle text-center">{{ index + 1 }}</td>
          <td class="align-middle">
            <b-button v-if="index > 2" size="sm" variant="danger" class="float-right" @click="deleteOutcome(index)"><font-awesome-icon icon="trash" class="m-0" /></b-button>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <span style="white-space: pre" v-html="newlineFormatter(outcome.title)" />
            <b-select v-if="index > 0" v-model="outcome.goal.planned" size="sm" style="margin-left: 10px;width: 80px;" :options="[70, 75, 80, 85, 90, 95, 100]" />
          </td>
          <td class="align-middle text-center">
            <template v-if="index === 0">{{ outcome.spending.planned | numeral('0,0.00') }}</template>
            <template v-else>{{ outcome.spending.planned || '-' }}</template>
          </td>
          <td class="align-middle text-center">-</td>
          <td class="align-middle text-center">
            <span v-if="index > 0">{{ outcome.goal.planned }}%</span>
            <span v-else>-</span>
          </td>
          <td class="align-middle text-center">-</td>
        </tr>
        <tr>
          <td colspan="6">
            <div class="form-inline">
              <b-select v-model="form.type" size="sm" :options="form.typeOptions" class="mr-1">
                <template slot="first">
                  <option :value="null" disabled>เลือกประเภทตัวชี้วัด</option>
                </template>
              </b-select>
              <b-input v-model="form.title" size="sm" class="mr-1" style="width: 300px;" />
              <span class="mr-1">คิดเป็นร้อยละ</span>
              <b-select v-model="form.value" size="sm" class="mr-1" style="width: 80px;" :options="[70, 75, 80, 85, 90, 95, 100]" />
              <b-button
                size="sm"
                variant="primary"
                @click="addOutcome"
              >
                <font-awesome-icon icon="plus-circle" />เพิ่มเป้าหมาย
              </b-button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </b-card>
</template>

<script>
import ProjectEditValidatorMixins from '@/mixins/projectEditValidatorMixins'
export default {
  mixins: [ ProjectEditValidatorMixins ],
  props: {
    value: { type: Array, required: true }
  },
  data () {
    return {
      outcomes: [],
      form: {
        type: null,
        typeOptions: [ 'เชิงปริมาณ', 'เชิงคุณภาพ' ],
        title: '',
        value: 0
      }
    }
  },
  watch: {
    value (newValue) { this.outcomes = newValue }
  },
  created () {
    this.outcomes = this.value
  },
  methods: {
    newlineFormatter (str) {
      return str.replace('\\n', '<br>')
    },
    addOutcome () {
      if (this.form.type !== null && this.form.title !== '') {
        this.value.push({
          title: `ตัวชี้วัด: ${this.form.type}<br>${this.form.title} คิดเป็นร้อยละ`,
          target: '',
          spending: { planned: null, actual: null },
          goal: { planned: this.form.value, actual: null }
        })

        this.form = {
          type: null,
          typeOptions: [ 'เชิงปริมาณ', 'เชิงคุณภาพ' ],
          title: '',
          value: 0
        }
      }
    },
    deleteOutcome (index) {
      this.$delete(this.outcomes, index)
      this.$emit('input', this.outcomes)
    }
  },
  validations: {
    value: {
      //
    }
  }
}
</script>

<style scoped lang="scss">

</style>
